import { useState } from 'react'

import { RejectCircleIcon } from 'src/assets/icons'
import { DeleteConfirmModal } from './delete-confirm-modal'
import { SettingsDropdown } from 'src/components/settings-dropdown'
import { useAccount, useRemoveAccount } from 'src/hooks'
import { EAccountRoles } from 'src/types'
import { AppEvents } from 'src/constants'
import { useTranslation } from 'react-i18next'

const CloseAccountButton = () => {
  const [t] = useTranslation()
  const [open, setOpen] = useState(false)
  const { mutateAsync: removeAccount } = useRemoveAccount()
  const { data: account } = useAccount()

  const handleOpen = () => {
    if (!account?.currentRoles.includes(EAccountRoles.owner)) {
      const detail = {
        message: t('close-account-owner-warning.v'),
      }
      const event = new CustomEvent(AppEvents.HTTP_ERROR, { detail })
      return document.dispatchEvent(event)
    }

    setOpen(true)
  }
  const handleClose = () => setOpen(false)

  const handleDelete = async () => {
    const resp = await removeAccount()
    if (!resp) return

    handleClose()
  }

  return (
    <>
      <SettingsDropdown
        onButtonClick={handleOpen}
        text={t('close-account-button-text.v')}
        icon={<RejectCircleIcon />}
      />
      {account && (
        <DeleteConfirmModal
          account={account}
          handleClose={handleClose}
          handleDelete={handleDelete}
          open={open}
        />
      )}
    </>
  )
}

export { CloseAccountButton }
